import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Alert, CircularProgress, Grid, Tabs, Tab } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getCurrencies, createCurrency, getExchangeRates, createExchangeRate } from '../../../services/api';

const MultiCurrency = () => {
  const [tab, setTab] = useState(0);
  const [currencies, setCurrencies] = useState([]);
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [curDialog, setCurDialog] = useState(false);
  const [rateDialog, setRateDialog] = useState(false);
  const [curForm, setCurForm] = useState({ code: '', name: '', symbol: '' });
  const [rateForm, setRateForm] = useState({ from_currency_id: '', to_currency_id: '', rate: 1, effective_date: new Date().toISOString().split('T')[0] });

  useEffect(() => { loadData(); }, [tab]);
  const loadData = async () => {
    try {
      setLoading(true);
      const [c, r] = await Promise.all([getCurrencies(), getExchangeRates()]);
      setCurrencies(c.data || []);
      setRates(r.data || []);
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <ModuleHub moduleId="general-ledger" showFeatures={false}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}><Tab label="Currencies" /><Tab label="Exchange Rates" /></Tabs>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => tab === 0 ? setCurDialog(true) : setRateDialog(true)}>
          {tab === 0 ? 'Add Currency' : 'Add Rate'}
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : tab === 0 ? (
        <TableContainer component={Paper}><Table>
          <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Name</TableCell><TableCell>Symbol</TableCell><TableCell>Base</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
          <TableBody>{currencies.map(c => (
            <TableRow key={c.id}><TableCell><strong>{c.code}</strong></TableCell><TableCell>{c.name}</TableCell><TableCell>{c.symbol}</TableCell>
              <TableCell>{c.is_base && <Chip label="Base" size="small" color="primary" />}</TableCell>
              <TableCell><Chip label={c.is_active ? 'Active' : 'Inactive'} size="small" color={c.is_active ? 'success' : 'default'} /></TableCell>
            </TableRow>
          ))}</TableBody>
        </Table></TableContainer>
      ) : (
        <TableContainer component={Paper}><Table>
          <TableHead><TableRow><TableCell>From</TableCell><TableCell>To</TableCell><TableCell align="right">Rate</TableCell><TableCell>Effective Date</TableCell></TableRow></TableHead>
          <TableBody>{rates.map(r => (
            <TableRow key={r.id}>
              <TableCell>{r.fromCurrency?.code || r.from_currency_id}</TableCell>
              <TableCell>{r.toCurrency?.code || r.to_currency_id}</TableCell>
              <TableCell align="right">{parseFloat(r.rate).toFixed(6)}</TableCell>
              <TableCell>{r.effective_date}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table></TableContainer>
      )}
      <Dialog open={curDialog} onClose={() => setCurDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add Currency</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={4}><TextField fullWidth label="Code" value={curForm.code} onChange={(e) => setCurForm({ ...curForm, code: e.target.value.toUpperCase() })} /></Grid>
          <Grid item xs={8}><TextField fullWidth label="Name" value={curForm.name} onChange={(e) => setCurForm({ ...curForm, name: e.target.value })} /></Grid>
          <Grid item xs={12}><TextField fullWidth label="Symbol" value={curForm.symbol} onChange={(e) => setCurForm({ ...curForm, symbol: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setCurDialog(false)}>Cancel</Button><Button variant="contained" onClick={async () => { await createCurrency(curForm); setCurDialog(false); loadData(); }}>Save</Button></DialogActions>
      </Dialog>
      <Dialog open={rateDialog} onClose={() => setRateDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Exchange Rate</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6}><TextField fullWidth select label="From" SelectProps={{ native: true }} value={rateForm.from_currency_id} onChange={(e) => setRateForm({ ...rateForm, from_currency_id: e.target.value })}><option value="">Select</option>{currencies.map(c => <option key={c.id} value={c.id}>{c.code}</option>)}</TextField></Grid>
          <Grid item xs={6}><TextField fullWidth select label="To" SelectProps={{ native: true }} value={rateForm.to_currency_id} onChange={(e) => setRateForm({ ...rateForm, to_currency_id: e.target.value })}><option value="">Select</option>{currencies.map(c => <option key={c.id} value={c.id}>{c.code}</option>)}</TextField></Grid>
          <Grid item xs={6}><TextField fullWidth type="number" label="Rate" value={rateForm.rate} onChange={(e) => setRateForm({ ...rateForm, rate: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={rateForm.effective_date} onChange={(e) => setRateForm({ ...rateForm, effective_date: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setRateDialog(false)}>Cancel</Button><Button variant="contained" onClick={async () => { await createExchangeRate({ ...rateForm, from_currency_id: parseInt(rateForm.from_currency_id), to_currency_id: parseInt(rateForm.to_currency_id), rate: parseFloat(rateForm.rate) }); setRateDialog(false); loadData(); }}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default MultiCurrency;
